export const HOME = {
  intro: {
    id: "what-is-fmc",
    title: "Що таке FMC?",
    blocks: [
      {
        t: "p",
        c: "У цьому гайді я спробую пояснити айсберг, яким є збірка на кількість ходів — почати можна дуже просто, але як би довго ти не копав, завжди є щось нове.",
      },
      {
        t: "p",
        c: "Я опишу поетапно збірку **фрідріхом** (відносно просто збирати саб40), збірку **блокбілдингом зі вставками** (відносно просто збирати за 29–30) і збірку **DR + HTR** (метод, яким збирають світові топи за 21–22 рухи), надаючи коментарі та ресурси. Головне — не забувайте, що практикувати вивчене не менш важливо, ніж вивчати нові техніки: саме техніки, бо алгоритмів, як ви їх знаєте в кх, достатньо мало, і все тримається на техніках та їхньому розумінні.",
      },
      {
        t: "note",
        tone: "info",
        title: "Що ж таке кх?",
        c: "Кх (FMC) — це збірка кубика Рубіка на кількість ходів. За правилами у вас є **година часу** і до **3 кубів**, щоб знайти та записати якнайбільш оптимальне рішення певного стану кубика. Збирати можна будь-яким методом, поки ваше рішення влазить у **80 рухів**, тому почати можна навіть не вивчаючи нічого нового.",
      },
    ],
  },
  roadmapIntro: {
    id: "roadmap",
    title: "Карта техніки",
    blocks: [
      {
        t: "p",
        c: "Спільнота кх любить малювати цей шлях як айсберг: на поверхні — те, з чим більшість уже знайома, а що глибше — то менш очевидні речі. Натисніть на пункт, щоб перейти до відповідного розділу.",
      },
    ],
  },
  cfop: {
    id: "cfop",
    title: "CFOP і перші кроки",
    blocks: [
      {
        t: "p",
        c: "Зазвичай люди, які починають цікавитись збіркою на кількість рухів, уже знають CFOP (він же фрідріх), хоча б частково — тому почну звідси.",
      },
      {
        t: "p",
        c: "CFOP є абсолютно нормальним методом для збірки на кількість рухів, і донедавна український національний рекорд був встановлений саме звичайним фрідріхом, з додаванням однієї техніки, до якої ми дійдемо пізніше (мова про [NISS](/blockbuilding#niss)).",
      },
      {
        t: "p",
        c: "Ресурсів у цій секції я не даватиму, але є декілька рекомендацій.",
      },
      {
        t: "list",
        items: [
          "**Пробуйте, пробуйте багато.** У вас є ціла година — використайте її з користю. Пробуйте збирати з різних кольорів, у різному порядку пар і заганяючи їх по-різному, поки не знайдете щось везуче, і навіть тоді не зупиняйтесь шукати.",
          "**Навчіться записувати рішення без перехватів.** На початку це може здаватись незвичним, але запам'ятати, яка грань якій літері відповідає, достатньо просто — і дуже зручно, а через декілька секцій стане необхідно. Не роблячи перехватів, у вас не буде проблем, що ви випадково перехопили, поки записували, і не знаєте, як продовжувати, не побачили, що хід скорочується, чи взагалі написали не той хід і отримали DNF.",
        ],
      },
    ],
  },
  community: {
    id: "community",
    title: "Спільнота",
    blocks: [
      {
        t: "p",
        c: "Одразу зазначу корисні групи, де можна отримати відповіді на питання — вони корисні на кожному етапі, не тільки на початку.",
      },
    ],
  },
};
